<template>
  <div id="slideshow">
    <flickity ref="flickity" :options="flickityOptions">
      <div v-for="(item, index) in content" class="carousel-cell" :key="index">
        <img :src="item.sizes.large" :width="item.sizes['large-width']" :height="item.sizes['large-height']" />
      </div>
    </flickity>
  </div>
</template>

<script>
import Flickity from 'vue-flickity';
export default {

  name: 'Slider',

  data () {
    return {
      flickityOptions: {
        pageDots: false,
        wrapAround: true

        // any options from Flickity can be used
      }
    }
  },

  components: {
    Flickity
  },

  props: ['content']
}
</script>

<style lang="css" scoped>
  #slideshow {
    margin-bottom: 3em;

    .carousel-cell {
      width: 100vw;
      height: 60vh;
      text-align: center;
      background: rgb(30,30,30);
      overflow: hidden;
    }

    @media (--phone) {
      .carousel-cell {
        height: 30vh;
      }
    }

    >>>.flickity-prev-next-button.previous {
      left: 25px;
    }

    >>>.flickity-prev-next-button.next {
      right: 25px;
    }

    img {
      object-fit: contain;
      height: 100%;
    }
  }
</style>
